/**
 * Web shim for react-native-tts
 * Uses the Web Speech Synthesis API.
 */

const Tts = {
  speak: async (text: string) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'it-IT';
      utterance.rate = 1.0;
      window.speechSynthesis.speak(utterance);
    }
  },
  stop: () => {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
    }
  },
  setDefaultLanguage: (_lang: string) => {},
  setDefaultRate: (_rate: number) => {},
  addEventListener: (_event: string, _handler: () => void) => {},
  removeEventListener: (_event: string, _handler: () => void) => {},
};

export default Tts;
